import { render, staticRenderFns } from "./results.vue?vue&type=template&id=c4f2b1e8&scoped=true&"
import script from "./results.vue?vue&type=script&lang=ts&"
export * from "./results.vue?vue&type=script&lang=ts&"
import style0 from "./results.vue?vue&type=style&index=0&id=c4f2b1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2b1e8",
  null
  
)

export default component.exports